module.exports = __webpack_public_path__ + "img/reginfo9.a4b52979.svg";